import React, { useCallback, useRef, useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { auth, db } from "../../firebase";
import { doc, getDoc, updateDoc } from 'firebase/firestore';

import { isMobile } from 'react-device-detect';
import axios from 'axios';

import Popup from "../Popup";
import Loading from '../Loading';
import ImportReleasedArtistPopup from "./ImportReleasedArtistPopup";
import ImportUnreleasedArtistPopup from "./ImportUnreleasedArtistPopup";
import MusicianGalleryPopup from "./MusicianGalleryPopupNew";
import CheckBoxSelector from "./CheckBoxSelector"

import MusicardPopup from '../Musicard/MusicardPopup';
import MusicardPopupMobile from '../Musicard/mobile/MusicardPopup';

import Share from '../Musicard/Share';
import ShareMobile from '../Musicard/mobile/Share';

import { CreateInitialMusicard } from './CreateInitialMusicard';

import styleClasses from './css/CreateMusicardPage.module.scss'; // 기존 MyPage 모듈 스타일 사용

function MusicardCreatePage() {

  const navigate = useNavigate();
  // 상태 변수들
  const musicianNameRef = useRef();
  const [musicianName, setMusicianName]           = useState('');
  const [musicianNameError, setMusicianNameError] = useState('');

  const [profilePicUrl, setProfilePicUrl]     = useState('');
  const [apiResults, setApiResults]           = useState([]);
  // const [selectedResults, setSelectedResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [authToken, setAuthToken] = useState(""); // Firebase ID 토큰
  const [uid, setUid] = useState(null);
  const [image, setImage] = useState('');   // 이미지 URL (표시용)

  // 팝업
  const [openPopup, setOpenPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');

  // 도메인 ID 과련
  const [idError, setIDError]               = useState('');
  const [idInput, setIdInput]               = useState('');
  const [idErrorText, setIDErrorText]       = useState('');
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [notDuplicate, setNotDuplicate]     = useState(false);

  const [duplicateLoading, setDuplicateLoading]  = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [genreError, setGenreError]       = useState(false);
  const [positionError, setPositionError] = useState(false);

  const [showShare, setShowShare]         = useState(false);
  const [qrImage, setQrImage]             = useState('');


  // const [isImageLoading, setIsImageLoading] = useState(false);
  const [openGalleryPopup, setOpenGalleryPopup] = useState(false);
  const [pushAlbums, setPushAlbums] = useState([]); // 부모에서 관리
  const [loadingMessage, setLoadingMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false); // 성공 여부
  const [redirectUrl, setRedirectUrl] = useState(""); // 성공 후 이동할 뮤지카드 URL
  const [musicardID, setMusicardID] = useState('');


  // URL 쿼리 파라미터에서 "music" 값을 추출 (released 또는 unreleased)
  const [searchParams]  = useSearchParams();

  const musicParam      = searchParams.get('music');
  const typeParam       = searchParams.get("type");

  const isSubmitting    = useRef(false);
  const idRef           = useRef();
  const [genreOptions, setGenreOptions]         = useState([]);
  const [positionOptions, setPositionOptions]   = useState([]);

  const [importPopupOpen, setImportPopupOpen]   = useState(false);
  const [importLoading, setImportLoading]       = useState(false);
  const [formData, setFormData]                 = useState({
    id: "",
    name: "",
    genres: [],
    positions: [],
    profileImage: "",
  });
  const [disabledButton, setDisabledButton]   = useState(true);
  
  // 🔹 현재 로그인된 사용자 UID 및 토큰 가져오기 + 뮤지카드 확인
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUid(user.uid);
        const token = await user.getIdToken();
        setAuthToken(token);

        if (uid) {
          const userRef = doc(db, "users", uid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            
            // musicard와 cardslot 값 추출
            const musicardObj = userData.musicard || {};
            const cardslot = Number(userData.cardslot) || 0;
            
            // musicard 엔트리 수 계산
            const musicardCount = Object.values(musicardObj).length;
            
            // 만약 뮤지카드 개수가 cardslot 이상이면 내 페이지로 이동
            if (musicardCount >= cardslot) {
              navigate("/my-page");
            }
          }
        }
      }
    });
    return () => unsubscribe();
  }, [uid, navigate]);

  const fetchMetadata = useCallback(async () => {
    try {
      const genresRef = doc(db, "metadata", "genres");
      const positionsRef = doc(db, "metadata", "positions");

      const genresSnap = await getDoc(genresRef);
      const positionsSnap = await getDoc(positionsRef);

      if (genresSnap.exists()) setGenreOptions(genresSnap.data().list);
      if (positionsSnap.exists()) setPositionOptions(positionsSnap.data().list);
    } catch (error) {
      console.error("메타데이터 불러오기 실패:", error);
    }
  }, []);

  useEffect(() => {
    if (typeParam === "team") {
      setFormData((prev) => ({
        ...prev,
        positions: prev.positions.includes("Group/Band") ? prev.positions : [...prev.positions, "Group/Band"]
      }));
    }
  }, [typeParam]);

  const reloadFormData = useCallback(async () => {
    if (!uid) return;
    const userRef = doc(db, "users_data", uid);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists()) {
      const data = userSnap.data();
      const profileImage = data.profileImage || "";
      const musicardId = data.musicardId || "";
      setProfilePicUrl(profileImage);
      setFormData((prev) => ({ ...prev, profileImage, id: musicardId }));
      setIdInput(musicardId);
      if (!musicardId && musicianName) {
        const recommended = musicianName.trim().replace(/\s+/g, "_").replace(/[^A-Za-z0-9_]/g, "");
        setIdInput(recommended);
        setFormData((prev) => ({ ...prev, id: recommended }));
      }
    }
  }, [musicianName, uid]);

  useEffect(() => {
    if (!uid) return;
    fetchMetadata();
    reloadFormData();
  }, [reloadFormData, fetchMetadata, uid]);

  // [데이터 가져오기] 버튼 클릭: 뮤지션 활동명을 기반으로 API 호출
  const handleFetchData = async () => {
    if (!musicianName.trim()) {
      setMusicianNameError('error');
      setError('뮤지션 활동명을 입력하세요.');
      return;
    }

    setMusicianNameError('');
    setError('');
    // setLoading(true);
    // setSelectedResults([]); // 기존 선택 초기화
    setImportPopupOpen(true); // 결과 팝업 열기
    setImportLoading(true);
    
    try {
      const endpoint =
        musicParam === 'released'
          ? `https://music-api-134893551192.asia-northeast3.run.app/api/artist/released?musicianName=${encodeURIComponent(musicianName)}`
          : `https://music-api-134893551192.asia-northeast3.run.app/api/artist/unreleased?musicianName=${encodeURIComponent(musicianName)}`;
      
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      
      // 응답은 단일 API 결과 배열
      const data = response.data;
      let combinedResults = [];
      if (musicParam === 'released') {
        combinedResults = data.youtubeResults || [];
      } else {
        combinedResults = data.soundcloudResults || [];
      }
      setApiResults(combinedResults);
      // setSelectedResults([]); // 기존 선택 초기화
      // setImportPopupOpen(true); // 결과 팝업 열기
      setImportLoading(false);

    } catch (err) {
      console.error(err);
      setMusicianNameError('error');
      setError('데이터를 가져오는 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const openGalleryForProfile = () => {
    setOpenGalleryPopup(true);
  };

  const handleSelectImage = async (imageUrl) => {
    if (!uid) return;
    try {
      const userRef = doc(db, "users_data", uid);
      await updateDoc(userRef, { profileImage: imageUrl });
      setProfilePicUrl(imageUrl);
      setImage(imageUrl);
      formData.profileImage = imageUrl;
    } catch (error) {
      console.error("Firestore에 이미지 저장 오류:", error);
    }
    setOpenGalleryPopup(false);
  };

  // 🔹 ID 유효성 검사 및 에러 초기화
  const resetError = (event) => {
    if (event.target.id === 'ID') {
      setIDError('');
      setIDErrorText('');
    }
  };

  // 중복 확인 (기존 로직 일부 유지)
  const handleDuplicateCheck = async () => {
    const trimmedId = idInput.trim();
    if (!trimmedId) {
      setOpenPopup(true);
      setPopupTitle('도메인 설정 ID를 입력해주세요.');
      return;
    } else if (!/^[A-Za-z0-9_]+$/.test(trimmedId)) {
      setIDError('error');
      setIDErrorText('ID에는 알파벳, 숫자, 밑줄(_)만 사용할 수 있습니다.');
      return;
    }

    setDuplicateLoading(true);

    const docRef = doc(db, "musicians", trimmedId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      setIDError('error');
      setIDErrorText('이미 사용 중인 주소입니다.');
      setNotDuplicate(false);
      setDuplicateLoading(false);
      return;
    } else {
      setCheckDuplicate(true);
      setNotDuplicate(true);
      setDuplicateLoading(false);
    }
    setFormData((prev) => ({ ...prev, id: trimmedId }));
    setIDError('');
    setIDErrorText('');
  };

  const handleCreateMusicard = () => {
    if (!formData.id) {
      setIDError('error');
      setIDErrorText('도메인 설정 ID를 입력해주세요.');
      setOpenPopup(true);
      setPopupTitle('도메인 설정 ID를 입력해주세요.');
      if (idRef.current) { idRef.current.focus(); }
      return;
    } else if (checkDuplicate === false) {
      setOpenPopup(true);
      setPopupTitle('도메인 설정 ID 중복을 확인해주세요.');
      return;
    } else if (formData.genres.length === 0) {
      setGenreError(true);
      return;
    } else if (formData.positions.length === 0) {
      setPositionError(true);
      return;
    }
    
    setButtonLoading(true);
    const fallbackName = musicianName.trim() ?? formData.id;

    const updatedFormData = {
      ...formData,
      name: fallbackName,
      profileImage: profilePicUrl
    };
  
    setMusicardID(formData.id);

    CreateInitialMusicard(updatedFormData, musicParam, pushAlbums, setLoading, setLoadingMessage, 
      (url, qr) => { setIsSuccess(true); setLoading(false); setRedirectUrl(url); setQrImage(qr); 
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "mzc_generate_complete"
        });
      }
    );
    
    setButtonLoading(false);
  };  

  // 🔹 제출 버튼 활성화 여부
  useEffect(() => {
    if (formData) {
      if (formData.id === '' && formData.name === '') {
        setDisabledButton(true);
      } else if (formData.genres.length === 0) {
        setDisabledButton(true);
      } else if (formData.positions.length === 0) {
        setDisabledButton(true);
      } else {
        setDisabledButton(false);
      }
    }
  }, [formData]);

  return (
    <>
      {/* 뮤지카드 생성 영역 */}
      <div className={ styleClasses.createMusicard }>
        <div className={ styleClasses.inner }>
          {
            !isSuccess &&
            (
              <div className={ styleClasses.title }>
                <h1>뮤지카드 입력</h1>
              </div>
            )
          }
          {
            (loading || isSuccess)
            ?
            (
              <div className={ styleClasses.fullScreenCenter }>
              {
                loading && <Loading message={loadingMessage} />
              }
              {
                isSuccess
                &&
                (
                <div className={styleClasses.successScreen}>
                    <h2>뮤지카드가 완성되었어요!</h2>
                    <p>링크를 공유하면 더 많은 사람들에게 나를 알릴 수 있어요. <br />인스타그램 프로필 링크, QR 명함으로 활용해보세요.</p>
                    <div className={ styleClasses.instagramPreview }>
                      <span className={ styleClasses.musicianID }>{ formData.id }</span>
                      <img src={ formData.profileImage } alt="완료" />
                      <span className={ styleClasses.musicianName }>{ formData.id || formData.name }</span>
                      {
                        formData.positions.length > 0
                        &&
                        <span className={ styleClasses.positions }>{ formData.positions.join(', ') }</span>
                      }
                      <span className={ styleClasses.positions }>Producer</span>
                      <div className={ styleClasses.previewLink }>
                        🔽 지금까지의 음악들, 여기에 있어요
                        <p>{`https://musizic.com/musicard/${ musicardID }`}</p>
                      </div>
                    </div>
                    <div className={ styleClasses.shareBox }>
                      <input type='text' readOnly value={`https://musizic.com/musicard/${ musicardID }`} />
                      <div className="commonButton">
                        <button className='black' onClick={ () => setShowShare(true) }>
                          <div className='commonIcon'>
                            <i className='shareWhite w24'></i>
                            공유하기
                          </div>
                        </button>
                      </div>
                    </div>
                    <div className={`commonButton fullWidth ${ styleClasses.successButtons }`}>
                      <button onClick={ () => navigate('/my-page/portfolio', { state: { musicardID: musicardID } }) } className='black'>
                        바로 포트폴리오 만들기
                      </button>
                      <Link to={ redirectUrl } className='black'>뮤지카드 보러가기</Link>
                    </div>
                </div>
                )
              }
              </div>
            )
            :
            (
              <div className="commonForm">
                {/* 뮤지션 활동명 입력 및 데이터 가져오기 */}
                <div className="formRow fullWidth">
                  <div className="labelBox">
                    <label>활동명</label>
                  </div>
                  <div className={`fieldBox ${ styleClasses.withButton } ${ musicianNameError }`}>
                    <input
                      type="text"
                      value={musicianName}
                      ref={ musicianNameRef }
                      onChange={e => {
                        setMusicianName(e.target.value);
                        setMusicianNameError('');
                        setFormData((prev) => ({ ...prev, name: e.target.value }));
                      }}
                      placeholder="뮤지션 활동명을 입력하세요"
                    />
                    <div className={`commonButton fullWidth ${ styleClasses.buttonBox }`}>
                      <button onClick={ handleFetchData }>
                        데이터 가져오기
                      </button>
                    </div>
                    {/* 에러 메시지 */}
                    <div className="fieldError">
                      <p>{ error }</p>
                    </div>
                  </div>
                </div>

                {/* 프로필 이미지 등록란 */}
                <div className="formRow fullWidth">
                  <div className="labelBox">
                    <label>
                      프로필 이미지
                      <div className="commonIcon toolTip">
                        <i className="questionBlack w16"></i>
                        <div className="toolTipText bottom">
                          <p>설정한 이미지는 뮤지카드 대표 이미지로 사용돼요.</p>
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className={`fieldBox ${ styleClasses.uploadImage }`}>
                    <label htmlFor="profile-image" onClick={ openGalleryForProfile }>
                    {
                      profilePicUrl
                      ?
                      (
                        <div className={ styleClasses.previewImage }>
                          <img src={ profilePicUrl } alt="프로필 이미지" className={ styleClasses.previewImage } />
                          <div className={`commonIcon ${ styleClasses.uploadIcon }`}>
                            <i className="uploadWhite w24"></i>
                          </div>
                        </div>
                      )
                      :                          
                      <div className={ styleClasses.purpleButton }>갤러리에서 선택</div>
                    }
                    </label>
                  </div>
                </div>

                {/* 도메인 설정 */}
                <div className="formRow fullWidth">
                  <div className="labelBox">
                    <label htmlFor="ID">
                      도메인 설정
                      <span className={ styleClasses.labelDescription }>
                        도메인은 최초 1회만 설정할 수 있어요. 설정 후에는 수정이 불가능해요.
                      </span>
                    </label>
                  </div>
                  <div className={`fieldBox ${ styleClasses.withButton } ${idError}`}>
                    <label htmlFor='ID' className={ styleClasses.urlPrefix }>https://musizic.com/musicard/<span className={ styleClasses.only768 }>{ idInput }</span></label>
                    <input
                      type="text"
                      id="ID"
                      value={ idInput }
                      ref={ idRef }
                      className={ styleClasses.nextInput }
                      onChange={(e) => {
                        setIdInput(e.target.value);
                        setFormData((prev) => ({ ...prev, id: e.target.value }));
                        resetError(e);
                        setNotDuplicate(false);
                        setCheckDuplicate(false);
                      }}
                      placeholder="예: Musizic"
                    />
                    <div className={`commonIcon toolTip ${ styleClasses.toolTopInInput }`}>
                      <i className="questionBlack w16"></i>
                      <div className="toolTipText bottom">
                        <p>활동명을 기반으로 추천 도메인을 자동 입력했어요. <br />직접 수정도 가능해요.</p>
                      </div>
                    </div>
                    <div className={`commonButton fullWidth ${ styleClasses.buttonBox }`}>
                      <button onClick={ handleDuplicateCheck } className="black">
                        중복 확인
                        <div className={`buttonLoading ${ duplicateLoading && 'active' }`}>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </button>
                    </div>
                    <div className="fieldError">
                      <p>{ idErrorText }</p>
                    </div>
                    {
                      (!notDuplicate && !idError)
                      &&
                      <p className={ styleClasses.infoMessage }>영문, 숫자, 밑줄(_)만 입력할 수 있어요.</p>
                    }
                    {
                      notDuplicate && <p className={ styleClasses.notDuplicate }>사용 가능한 주소입니다.</p>
                    }
                  </div>
                </div>

                {/* 포지션 선택 */}
                {
                  !formData.positions.includes("Group/Band")
                  &&
                  (
                    <CheckBoxSelector
                        label="포지션 선택"
                        options={positionOptions}
                        selectedItems={formData.positions}
                        setSelectedItems={(newItems) => { setFormData((prev) => ({ ...prev, positions: newItems })); setPositionError(false); }}
                        styleClasses={styleClasses}
                    />
                  )
                }
                {
                  positionError && <p className={ styleClasses.checkBoxError }>최소 1개 이상의 항목을 선택해주세요.</p> 
                }

                {/* 장르 선택 */}
                <CheckBoxSelector
                  label="장르 선택"
                  options={genreOptions}
                  selectedItems={formData.genres}
                  setSelectedItems={(newItems) => { setFormData((prev) => ({ ...prev, genres: newItems })); setGenreError(false); } }
                  styleClasses={styleClasses}
                />
                {
                  genreError && <p className={ styleClasses.checkBoxError }>최소 1개 이상의 항목을 선택해주세요.</p> 
                }

                <div className={ styleClasses.formButtons }>
                  <div className="commonButton fullWidth">
                    <button className={`black ${ disabledButton ? styleClasses.disabled : undefined }`} onClick={ handleCreateMusicard } disabled={ disabledButton }>
                      저장하기
                      <div className={`buttonLoading ${ buttonLoading ? 'active' : undefined }`}>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
      {/* editPage 종료 */}
      <Popup
        open={ openPopup }
        setOpenPopup={ setOpenPopup }
        title={ popupTitle }
        text={ null }
        buttonText={ null}
        buttonFunction={ null}
        buttonLoading={ false }
      />

      {/* 이미지 업로드 팝업 */}
      <MusicianGalleryPopup
        uid={ uid }
        open={ openGalleryPopup }
        setOpenPopup={ setOpenGalleryPopup }
        imageIndex={ 5 }
        buttonFunction={ handleSelectImage }
        onSelectImage={ handleSelectImage }
      />
      
      {/* API 호출 결과를 팝업에서 보여줌 */}
      {
        musicParam === "unreleased"
        ?
        (
          <ImportUnreleasedArtistPopup
            open={importPopupOpen && musicParam === "unreleased"}
            setOpenPopup={(value) => {
                setImportPopupOpen(value);
                if (!value) reloadFormData();
            }}
            apiResults={apiResults}
            pushAlbums={pushAlbums}
            setPushAlbums={setPushAlbums}
            loading={ importLoading }
          />
        )
        :
        (
          <ImportReleasedArtistPopup
            open={importPopupOpen && musicParam === "released"}
            setOpenPopup={(value) => {
            setImportPopupOpen(value);
            if (!value) reloadFormData();
            }}
            apiResults={apiResults}
            pushAlbums={pushAlbums}
            setPushAlbums={setPushAlbums}
            loading={ importLoading }
          />
        )
      }

      {/* 공유하기 팝업 */}
      {
        showShare
        &&
        (
          !isMobile
          ?
          <MusicardPopup
            id={ idInput }  // 필요에 따라 전달 (예: 뮤지카드 id)
            setModalOpen={ setShowShare }
            closeStyle="share"
            element={
              <Share
                url={`https://musizic.com/musicard/${ idInput }`}  // previewPDF 함수에서 업로드 후 설정한 공유용 URL
                musician={ formData }  // 필요에 따라 실제 데이터를 전달
                image={ qrImage }
              />
            }
          />
          :
          <MusicardPopupMobile
            id={ idInput }  // 필요에 따라 전달 (예: 뮤지카드 id)
            setModalOpen={setShowShare}
            closeStyle="share"
            element={
              <ShareMobile
                url={`https://musizic.com/musicard/${ idInput }`}  // previewPDF 함수에서 업로드 후 설정한 공유용 URL
                musician={ formData }  // 필요에 따라 실제 데이터를 전달
                image={ qrImage }
              />
            }
          />
        )
      }
    </>
  );
}

export default MusicardCreatePage;